<template>
  <v-content>
    <v-container class="justify-center">
      <v-alert :value="displayAlert" :color="alertType">{{alertMsg}}</v-alert>
      <h1 class="subheading grey--text">Sign Up</h1>
      <v-form @keyup.native.enter="signup">
        <v-text-field label="Email Address" solo v-model="email" :rules="emailRules" required></v-text-field>
        <v-text-field
          label="Password"
          solo
          v-model="password"
          :append-icon="show ? 'visibility' : 'visibility_off'"
          :rules="[passwordRules.required, passwordRules.min]"
          :type="show ? 'text' : 'password'"
          name="input-10-1"
          hint="At least 8 characters"
          counter
          @click:append="show = !show"
          required
        ></v-text-field>

        <v-btn @click="signup">Sign Up</v-btn>
        <div>
          Already a member?
          <router-link to="/login">Log in</router-link>
        </div>
      </v-form>
    </v-container>
  </v-content>
</template>
<script>
import firebase from "firebase";
import { mapActions } from "vuex";
import axios from "axios";
import VueCookies from "vue-cookies";
import {
  userCreateApi,
  clientMemberAddApi,
  clientInviteReadApi
} from "@/config/appSettings";
export default {
  name: "signup",
  data() {
    return {
      email: "",
      password: "",
      show: false,
      alertMsg: "",
      alertType: "",
      displayAlert: false,
      auth : null, 
      passwordRules: {
        required: value => !!value || "Required.",
        min: v => v.length >= 8 || "Min 8 characters"
      },
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ]
    };
  },
  methods: {
    ...mapActions(["emailContactCreate"]),
    signup: function(e) {
      e.preventDefault();
      let self = this;

      firebase
        .auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then(
          () => {
            self.auth = firebase.auth().currentUser.uid
            //console.log(JSON.stringify(user));
            // alert(`Account Created for ${user}`);
            firebase
              .auth()
              .currentUser.sendEmailVerification()
              .then(function() {
                try {
                  

                  let newUser = {};
                  newUser.usertoken = firebase.auth().currentUser.uid;
                  newUser.email = firebase.auth().currentUser.email;

                  // REGISTER ADD MEMBER TO CAMPAIGN
                  if (!VueCookies.isKey("client_ref")) {
                    let inviteData = VueCookies.get("client_ref");

                    // LOAD
                    console.log("HERE IS INVITE DATA:", inviteData);

                    // ADD USER AS NEW MEMBER TO CLIENT
                    //let loadInvite = await axios.get(`${clientInviteReadApi}/?invite=${}`)
                    newUser.profileType = "client";
                    newUser.source = {
                      type: "clientInvite",
                      inviteId: inviteData.invid
                    };

                    // CREATE USER
                    axios.post(userCreateApi, newUser).then(userResponse => {
                      console.log("CREATE PROFILE RESULT:", userResponse.data);
                      if (userResponse.data.success === true) {
                        // LOAD INVITE
                        axios
                          .get(
                            `${clientInviteReadApi}/?invite=${inviteData.invid}`
                          )
                          .then(inviteResponse => {
                            console.log(
                              "CREATE PROFILE RESULT:",
                              inviteResponse.data
                            );
                            if (inviteResponse.data.success === true) {
                              // ADD MEMBER
                              let newMember = {}
                              newMember.client = inviteResponse.data.clientId 
                              newMember.usertoken = self.auth 
                              axios
                                .post(clientMemberAddApi, newMember)
                                .then(memberResponse => {
                                  console.log(
                                    "CREATE PROFILE RESULT:",
                                    memberResponse.data
                                  );
                                  if (memberResponse.data.success === true) {
                                    // ADD MEMBER
                                    console.log("MEMBER RESPONSE:", memberResponse)
                                    // UNSET COOKIE 
                                    VueCookies.remove("client_ref")
                                    console.log("CHECKING FOR KEY:", VueCookies.isKey("client_ref"))
                                  }
                                });
                            }
                          });
                      }
                    });
                  }

                  self.$router.push({
                    path: "login",
                    query: {
                      msg_show: true,
                      msg_type: "success",
                      msg: "Your're signed up! Log In below."
                    }
                  });
                } catch (err) {
                  console.log("ERROR:", err);
                }
              })
              .catch(function(err) {
                // Handle Errors here.

                console.log("There was an error: ", err);
                if (err.code === "auth/invalid-email") {
                  self.alertMsg = "Please enter a valid email.";
                }
                if (err.code === "auth/user-not-found") {
                  self.alertMsg = "Please enter a valid email.";
                } else {
                  self.alertMsg = err.message;
                }

                self.displayAlert = true;
                self.alertType = "error";
              });
          },
          err => {
            //console.log("There was an error: ", err);
            if (err.code === "auth/invalid-email") {
              self.alertMsg = "Please enter a valid email.";
            }
            if (err.code === "auth/user-not-found") {
              self.alertMsg = "Please enter a valid email.";
            } else {
              self.alertMsg = err.message;
            }

            self.displayAlert = true;
            self.alertType = "error";
          }
        );
    }
  }
};
</script>

<style scoped>
.float-left {
  float: left;
}
.checkbox {
  margin: 10px;
  padding: 3px;
}
.margin-10 {
  margin: 10px;
}
.error-check {
  outline: 3px solid red;
}
</style>